import {
    AppDependency,
    ApplicationToServer,
    Database,
    DatabaseApplication,
    DeserializedApplication,
    DeserializedServer,
    ServerCommunication,
} from '@amzn/awscat-portfolio-assessment-types';
import { createContext, FC, useState } from 'react';

export type InlineEditRowItem = 
    AppDependency | ApplicationToServer | DeserializedServer | DeserializedApplication | Database | DatabaseApplication | ServerCommunication;
export type InlineEditValue = string | number | boolean | null;
type InlineEditFn = (rowItem: InlineEditRowItem, columnId: string, updatedValue: InlineEditValue) => Promise<void>;
interface IInlineEditContext {
    pauseMouseAction: boolean;
    updatePauseMouseAction: (pauseAction: boolean) => void;
    inlineEditFunction: InlineEditFn;
    updateInlineEditFn: (inlineEditFn: InlineEditFn) => void;
}

export const InlineEditContext = createContext<IInlineEditContext>({
    pauseMouseAction: false,
    updatePauseMouseAction: () => {},
    inlineEditFunction: async () => {},
    updateInlineEditFn: () => {},
});

export const InlineEditProvider: FC = ({ children }) => {
    const [ pause, setPause ] = useState(false);
    const [ inlineEditFunction, setInlineEditFunction ] = useState<InlineEditFn>(() => async () => {});

    const updatePauseMouseAction = (pauseAction: boolean) => {
        setPause(pauseAction);
    };

    const updateInlineEditFn = (inlineEditFunc: InlineEditFn) => {
        setInlineEditFunction(() => inlineEditFunc);
    };

    return (
        <InlineEditContext.Provider
            value={{
                pauseMouseAction: pause,
                updatePauseMouseAction,
                inlineEditFunction,
                updateInlineEditFn,
            }}>
            {children}
        </InlineEditContext.Provider>
    );
};
